export default __webpack_public_path__ + "static/media/logo_feed_back.a2d748f4.svg";